<template>
  <BaseDialog :showCondition="show" @closed="closeDialog()">
    <template v-slot:title>
      <p class="primary--text">إضافة نصيحة أخلاقية</p>
    </template>
    <template v-slot:body>
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <v-form ref="form">
              <!-- TODO: fix rules -->
              <v-textarea
                :rules="[requiredRule]"
                v-model="advice"
                outlined
                persistent-placeholder
                label="النصيحة الأخلاقية"
                placeholder="أدخل نص النصيحة الأخلاقية هنا"
              ></v-textarea>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-slot:actions>
      <v-btn @click="sendCreateRequest()" class="accent rounded-pill px-10">
        إضافة
      </v-btn>
    </template>
  </BaseDialog>
</template>

<script>
import { mapActions } from "pinia";
import { useEthicalAdviceStore } from "../../store/EthicalAdviceStore";

import FormValidationRulesMixin from "@/core/mixins/FormValidationRulesMixin.vue";

export default {
  mixins: [FormValidationRulesMixin],
  props: {
    showCondition: Boolean,
  },
  watch: {
    showCondition: {
      immediate: true,
      handler() {
        this.show = this.showCondition;
      },
    },
  },
  data() {
    return {
      show: this.showCondition,
      advice: "",
    };
  },
  methods: {
    closeDialog() {
      this.show = false;
      this.$emit("closed");
      this.$refs.form.reset();
    },
    ...mapActions(useEthicalAdviceStore, ["createEthicalAdvice"]),
    sendCreateRequest() {
      if (this.$refs.form.validate()) {
        var data = { advice: this.advice };
        this.createEthicalAdvice(data);
        // TODO: close before or after??
        this.closeDialog();
      }
    },
  },
};
</script>
